if (!customElements.get("recharge-widget")) {
    class RechargeWidget extends HTMLElement {
        constructor() {
            super();
            this.selling_plan_input = null; // We store the input here
        }
        connectedCallback(){
            this.init();
        }
        init(){
            this.form = this.querySelector("form");
            this.form.addEventListener('change', this.onChange.bind(this));
            this.product_form = document.querySelector(`#${this.dataset.form}`);
            if(document.querySelector("sticky-cart-modal product-form form")) this.sticky_form = document.querySelector("sticky-cart-modal product-form form")
            this.one_time_radio = this.querySelector("#one_time");
            this.recurring_radio = this.querySelector("#recurring");
            this.select = this.querySelector(".recharge-widget-select__select")
            this.gift = this.querySelector(".recharge-widget-radio__gift")
            this.initSellingPlanInput();
        }
        onChange(event) {
            if (event.target && event.target.type === 'radio' && event.target.checked) {
                // If "recurring" is selected, we add the hidden input
                if (event.target.id === "recurring") { 
                    this.initSellingPlanInput();
                    
                    this.setInputValue(this.select?.value);
                    if(this.querySelector("[data-gift-variant]")){
                        const gift_input = document.createElement('input');
                        gift_input.type = "hidden",
                        gift_input.name= "properties[_recharge_gift_variant]"
                        gift_input.value = this.querySelector("[data-gift-variant]").dataset.giftVariant
                        this.gift_input = gift_input
                        this.product_form.appendChild(this.gift_input)
                    }
                }
                // If "one_time" is selected, we remove the "selling_plan" input
                else if (event.target.id === "one_time") {
                    this.setInputValue("");
                    if(this.gift_input && this.product_form){
                        this.product_form.removeChild(this.gift_input);
                        this.gift_input = null;
                    }
                }
                this.closest(".section").classList.toggle("plan-selected")
            }
            else if(event.target && event.target.classList.contains('recharge-widget-select__select')){
                if(!this.recurring_radio.checked) this.recurring_radio.checked = true;
                this.initSellingPlanInput();
                this.setInputValue(this.select?.value);
            }

            document.dispatchEvent(new CustomEvent('selling-plan::selected'))
        }
        initSellingPlanInput() {
            this.selling_plan_input = this.product_form.querySelector("input[name='selling_plan']");
            if (!this.selling_plan_input) { // Check if the input already exists
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'selling_plan';
            input.value = "";
            this.selling_plan_input = input; // Store the input in the element
            this.product_form.appendChild(input);
            }
            // Always ensure sticky_input is set if sticky_form exists
            if (this.sticky_form) {
            this.sticky_input = this.sticky_form.querySelector("input[name='selling_plan']");
            if (!this.sticky_input) {
                this.sticky_input = this.selling_plan_input.cloneNode(true);
                this.sticky_form.appendChild(this.sticky_input);
            }
            }
        }
        setInputValue(value){
            if(!value) return;
            if(this.selling_plan_input) this.selling_plan_input.value = value;
            if(this.sticky_input) this.sticky_input.value = value;
        }
    }
    customElements.define("recharge-widget", RechargeWidget);
}

  